
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyCoNdk4ms4dOJFAUKKszm9OZgFqGbn1h5k",
    authDomain: "catering-service-swg.firebaseapp.com",
    projectId: "catering-service-swg",
    storageBucket: "catering-service-swg.firebasestorage.app",
    messagingSenderId: "157041219800",
    appId: "1:157041219800:web:c525fa21b7ab9889251fad"
  };

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const auth = getAuth(app);
  const googleProvider = new GoogleAuthProvider();
  const functions = getFunctions(app);
  const projectId = firebaseConfig.projectId;
  const realtimeDb = getDatabase();

  // Ensure the user session persists across refresh
  setPersistence(auth, browserLocalPersistence);
  
  //export default db;
  
  export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};